export default __webpack_public_path__ + "static/media/emoji-money.66f729b8.svg";